import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import moment from "moment";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

import Face from "@material-ui/icons/Face";
// import Receipt from "@material-ui/icons/Receipt";

import Header from "../../components/Header/Header.jsx";
import Footer from "../../components/Footer/Footer.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";
import NavPills from "../../components/NavPills/NavPills.jsx";
// import Card from "../../components/Card/Card.jsx";
// import CardBody from "../../components/Card/CardBody.jsx";
// import CardHeader from "../../components/Card/CardHeader.jsx";
// import Muted from "../../components/Typography/Muted.jsx";
import Parallax from "../../components/Parallax/Parallax.jsx";
import Clearfix from "../../components/Clearfix/Clearfix.jsx";
import Button from "../../components/CustomButtons/Button.jsx";

import profilePhoto from "../../assets/img/faces/default-profile.jpg";
// import avatar from "../../assets/img/faces/avatar.jpg";
// import marc from "../../assets/img/faces/marc.jpg";
// import kendall from "../../assets/img/faces/kendall.jpg";
// import cardProfile2Square from "../../assets/img/faces/card-profile2-square.jpg";

import profilePageStyle from "../../assets/jss/material-kit-pro-react/views/profilePageStyle.jsx";

import translateRole from "../../utils/translateRole";
import Snackbar from "@material-ui/core/Snackbar";
import CustomNotification from "../LandingPage/Sections/CustomNotification";
// import Card from "../../components/Card/Card";

class ProfilePage extends React.Component {
    constructor() {
        super();
        this.state = {
            openNotification: false,
            variantNotification: '',
            messageNotification: ''
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;

        const { authReducer, history, location } = this.props;

        if (authReducer.user.toChangePass === true) {
            history.push({ pathname: '/reestablecimiento-contrasena', state: { message: 'Ingresa tu nueva contraseña', type: 'warning' } });
        } else if (!!location.state && !!location.state.message) {
            this.handleClickNotification(location.state.message, location.state.type);
        }
    }

    handleClickNotification = (messageNotification, variantNotification) => {
        this.setState({ openNotification: true, messageNotification, variantNotification });
    };

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') { return; }
        this.setState({ openNotification: false });
    };

    render() {
        const { classes, authReducer,
            // ...rest
        } = this.props;
        const { user } = authReducer;

        // const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);

        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>{!!user ? `${user.first_name} ${user.last_name}` : "Mi perfil"} | Vivamos el Campo - Turismo Rural</title>
                    <link rel="canonical" href="https://vivamoselcampo.co/profile" />
                </Helmet>

                <Header
                    fixed
                    brand="Vivamos el Campo Logo"
                    color="transparent"
                    links={<HeaderLinks dropdownHoverColor="info" />}
                    changeColorOnScroll={{
                        height: 200,
                        color: "white"
                    }}
                />
                <Parallax
                    image={require("../../assets/img/landing-bg.jpg")}
                    filter="dark"
                    className={classes.parallax}
                />
                <div className={classNames(classes.main, classes.mainRaised)}>
                    <div className={classes.container}>
                        {/* Custom Notification */}
                        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                            <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                        </Snackbar>
                        {/* End Custom Notification */}

                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={6} lg={6}>
                                <div className={classes.profile}>
                                    <div>

                                        {/*
                                        TODO: Implementar subida de foto del usuario
                                        */}
                                        <img src={profilePhoto} alt="Foto de perfil" title="Foto de perfil" className={classNames(classes.imgRaised, classes.imgRoundedCircle, classes.imgFluid)} />

                                    </div>
                                    <div className={classes.name}>

                                        <h3 className={classes.title}>{user.first_name} {user.last_name}</h3>
                                        <h4><strong>({user.username})</strong></h4>
                                        <h5>{ translateRole(user.role) }</h5>

                                        {/*
                                        TODO: Añadir información de redes sociales al usuario
                                        */}
                                        {/*<Button justIcon simple color="facebook" className={classes.margin5}>
                                            <i className={classes.socials + " fab fa-facebook"} />
                                        </Button>
                                        <Button justIcon simple color="twitter" className={classes.margin5}>
                                            <i className={classes.socials + " fab fa-twitter"} />
                                        </Button>
                                        <Button justIcon simple color="instagram" className={classes.margin5}>
                                            <i className={classes.socials + " fab fa-instagram"} />
                                        </Button>*/}
                                    </div>
                                </div>
                            </GridItem>
                        </GridContainer>
                        {/*
                        TODO: El usuario puede describirse a sí mismo
                        */}
                        {/*<div className={classNames(classes.description, classes.textCenter)}>
                            <p>
                                An artist of considerable range, Chet Faker — the name taken by
                                Melbourne-raised, Brooklyn-based Nick Murphy — writes, performs
                                and records all of his own music, giving it a warm, intimate
                                feel with a solid groove structure.{" "}
                            </p>
                        </div>*/}
                        <div className={classes.profileTabs}>
                            {/*
                            esto va dentro de tabs

                            ,{
                                        tabButton: "Reservaciones",
                                        tabIcon: Receipt,
                                        tabContent: (
                                            <div>
                                                <GridContainer justify="center">
                                                    <GridItem
                                                        xs={12}
                                                        sm={12}
                                                        md={5}
                                                        className={classes.gridItem}
                                                    >
                                                        <Card profile plain className={classes.card}>
                                                            <GridContainer>
                                                                <GridItem xs={12} sm={12} md={5}>
                                                                    <CardHeader image plain>
                                                                        <a href="#pablo">
                                                                            <img src={avatar} alt="..." />
                                                                        </a>
                                                                        <div
                                                                            className={classes.coloredShadow}
                                                                            style={{
                                                                                backgroundImage: "url(" + avatar + ")",
                                                                                opacity: "1"
                                                                            }}
                                                                        />
                                                                    </CardHeader>
                                                                </GridItem>
                                                                <GridItem xs={12} sm={12} md={7}>
                                                                    <CardBody plain>
                                                                        <h4 className={classes.cardTitle}>
                                                                            Gigi Hadid
                                                                        </h4>
                                                                        <Muted>
                                                                            <h6>MODEL</h6>
                                                                        </Muted>
                                                                        <p className={classes.description}>
                                                                            Don't be scared of the truth because we
                                                                            need to restart the human foundation in
                                                                            truth...
                                                                        </p>
                                                                    </CardBody>
                                                                </GridItem>
                                                            </GridContainer>
                                                        </Card>
                                                    </GridItem>
                                                    <GridItem
                                                        xs={12}
                                                        sm={12}
                                                        md={5}
                                                        className={classes.gridItem}
                                                    >
                                                        <Card profile plain className={classes.card}>
                                                            <GridContainer>
                                                                <GridItem xs={12} sm={12} md={5}>
                                                                    <CardHeader image plain>
                                                                        <a href="#pablo">
                                                                            <img src={marc} alt="..." />
                                                                        </a>
                                                                        <div
                                                                            className={classes.coloredShadow}
                                                                            style={{
                                                                                backgroundImage: "url(" + marc + ")",
                                                                                opacity: "1"
                                                                            }}
                                                                        />
                                                                    </CardHeader>
                                                                </GridItem>
                                                                <GridItem xs={12} sm={12} md={7}>
                                                                    <CardBody plain>
                                                                        <h4 className={classes.cardTitle}>
                                                                            Marc Jacobs
                                                                        </h4>
                                                                        <Muted>
                                                                            <h6>DESIGNER</h6>
                                                                        </Muted>
                                                                        <p className={classes.description}>
                                                                            Don't be scared of the truth because we
                                                                            need to restart the human foundation in
                                                                            truth...
                                                                        </p>
                                                                    </CardBody>
                                                                </GridItem>
                                                            </GridContainer>
                                                        </Card>
                                                    </GridItem>
                                                </GridContainer>
                                                <GridContainer justify="center">
                                                    <GridItem
                                                        xs={12}
                                                        sm={12}
                                                        md={5}
                                                        className={classes.gridItem}
                                                    >
                                                        <Card profile plain className={classes.card}>
                                                            <GridContainer>
                                                                <GridItem xs={12} sm={12} md={5}>
                                                                    <CardHeader image plain>
                                                                        <a href="#pablo">
                                                                            <img src={kendall} alt="..." />
                                                                        </a>
                                                                        <div
                                                                            className={classes.coloredShadow}
                                                                            style={{
                                                                                backgroundImage: "url(" + kendall + ")",
                                                                                opacity: "1"
                                                                            }}
                                                                        />
                                                                    </CardHeader>
                                                                </GridItem>
                                                                <GridItem xs={12} sm={12} md={7}>
                                                                    <CardBody plain>
                                                                        <h4 className={classes.cardTitle}>
                                                                            Kendall Jenner
                                                                        </h4>
                                                                        <Muted>
                                                                            <h6>MODEL</h6>
                                                                        </Muted>
                                                                        <p className={classes.description}>
                                                                            I love you like Kanye loves Kanye. Don't
                                                                            be scared of the truth.
                                                                        </p>
                                                                    </CardBody>
                                                                </GridItem>
                                                            </GridContainer>
                                                        </Card>
                                                    </GridItem>
                                                    <GridItem
                                                        xs={12}
                                                        sm={12}
                                                        md={5}
                                                        className={classes.gridItem}
                                                    >
                                                        <Card profile plain className={classes.card}>
                                                            <GridContainer>
                                                                <GridItem xs={12} sm={12} md={5}>
                                                                    <CardHeader image plain>
                                                                        <a href="#pablo">
                                                                            <img src={cardProfile2Square} alt="..." />
                                                                        </a>
                                                                        <div
                                                                            className={classes.coloredShadow}
                                                                            style={{
                                                                                backgroundImage:
                                                                                "url(" + cardProfile2Square + ")",
                                                                                opacity: "1"
                                                                            }}
                                                                        />
                                                                    </CardHeader>
                                                                </GridItem>
                                                                <GridItem xs={12} sm={12} md={7}>
                                                                    <CardBody plain>
                                                                        <h4 className={classes.cardTitle}>
                                                                            George West
                                                                        </h4>
                                                                        <Muted>
                                                                            <h6>MODEL/DJ</h6>
                                                                        </Muted>
                                                                        <p className={classes.description}>
                                                                            I love you like Kanye loves Kanye.
                                                                        </p>
                                                                    </CardBody>
                                                                </GridItem>
                                                            </GridContainer>
                                                        </Card>
                                                    </GridItem>
                                                </GridContainer>
                                            </div>
                                        )
                                    }
                            */}
                            <NavPills
                                alignCenter
                                color="success"
                                tabs={[
                                    {
                                        tabButton: "Información",
                                        tabIcon: Face,
                                        tabContent: (
                                            <GridContainer className={classes.textCenter}>
                                                <GridItem xs={12} sm={12} md={2} className={classes.gridItem}>
                                                </GridItem>

                                                <GridItem xs={12} sm={12} md={4} className={classes.gridItem}>
                                                    <h4 className={classes.title}>Datos de Usuario</h4>
                                                    <ul className={classes.listUnstyled}>
                                                        <li><b>Email:</b> {user.email}</li>
                                                        <li><b>Nombre de Usuario:</b> {user.username}</li>
                                                        <li><b>Fecha de registro:</b> {moment(user.createdAt).format("DD/MM/YYYY")}</li>
                                                    </ul>
                                                    {/*
                                                    TODO: Activar cambiar mi contraseña
                                                    */}
                                                    {/*<Button color="success" round>
                                                        Cambiar mi contraseña
                                                    </Button>*/}
                                                </GridItem>

                                                <GridItem xs={12} sm={12} md={4} className={classes.gridItem}>
                                                    <h4 className={classes.title}>Datos Personales</h4>
                                                    <ul className={classes.listUnstyled}>
                                                        <li><b>Nombre(s):</b> {user.first_name}</li>
                                                        <li><b>Apellidos:</b> {user.last_name}</li>
                                                        {(!!user.documentType && !!user.documentNumber) ?
                                                            <li><b>Documento de Identidad:</b> {user.documentType} {user.documentNumber}</li>
                                                            :
                                                            null
                                                        }
                                                        {(user.contact_info.phones.length>0 || user.contact_info.mobile.length>0) ?
                                                            <li><b>Telefono(s):</b>
                                                                {user.contact_info.phones.map((phone, index) => {
                                                                    return <p key={index}>{phone}</p>
                                                                })}
                                                                {user.contact_info.mobile.map((mobile, index) => {
                                                                    return <p key={index}>{mobile}</p>
                                                                })}
                                                            </li>
                                                            :
                                                            null
                                                        }
                                                        {!!user.country ?
                                                            <li><b>País:</b> {user.country}</li>
                                                            :
                                                            null
                                                        }
                                                        {!!user.city ?
                                                            <li><b>Ciudad:</b> {user.city}</li>
                                                            :
                                                            null
                                                        }
                                                        {!!user.address ?
                                                            <li><b>Dirección vivienda:</b> {user.address}</li>
                                                            :
                                                            null
                                                        }
                                                    </ul>
                                                </GridItem>

                                                <GridItem xs={12} sm={12} md={2} className={classes.gridItem}>
                                                </GridItem>
                                            </GridContainer>
                                        )
                                    }
                                ]}
                            />

                            {user.role === 'Owner'
                                ? (
                                    <GridContainer justify="center">
                                        <GridItem xs={12} sm={12} md={6} lg={6}>
                                            <Link to={'/gestionar-servicios'}>
                                                <Button block color="success">Gestionar mis servicios</Button>
                                            </Link>
                                        </GridItem>
                                    </GridContainer>
                                )
                                : null
                            }
                        </div>

                        <Clearfix />
                    </div>
                </div>

                <Footer
                    className={classes.footer}
                    content={
                        <div>
                            <div className={classes.left}>
                                <List className={classes.list}>
                                    <ListItem className={classes.inlineBlock}>
                                        <Link to="/" className={classes.block}> Inicio </Link>
                                    </ListItem>
                                    <ListItem className={classes.inlineBlock}>
                                        <Link to="/accommodations" className={classes.block}> Alojamientos </Link>
                                    </ListItem>
                                    <ListItem className={classes.inlineBlock}>
                                        <Link to="/tours" className={classes.block}> Tours </Link>
                                    </ListItem>
                                    <ListItem className={classes.inlineBlock}>
                                        <Link to="/contacto" className={classes.block}> Contacto </Link>
                                    </ListItem>
                                </List>
                            </div>

                            <div className={classes.right}> &copy; {1900 + new Date().getYear()} Vivamos el Campo. Todos los derechos reservados.</div>
                        </div>
                    }
                />
            </div>
        );
    }
}

ProfilePage.propTypes = {
    // registerUser: PropTypes.func.isRequired,
    authReducer: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    authReducer: state.authReducer
});

export default connect(mapStateToProps, null)( withStyles(profilePageStyle)(ProfilePage) );



// WEBPACK FOOTER //
// ./src/views/ProfilePage/ProfilePage.jsx